var DealStatus = require("./deal-status");

var DealStatusBox = React.createClass({
  propTypes: {
    dealStatus: React.PropTypes.object.isRequired
  },

  statuses: [
    {
      id: 3,
      label: "Perdido",
      icon: "lost",
      selectedClass: "lost"
    },
    {
      id: 1,
      label: "Em andamento",
      icon: "progress",
      selectedClass: "in-progress"
    },
    {
      id: 2,
      label: "Ganho",
      icon: "won",
      selectedClass: "won"
    }
  ],

  render: function() {
    return (
      <div className="ta-c">
        {this.statuses.map(status =>
          <DealStatus
            key={status.id}
            label={status.label}
            icon={status.icon}
            selected={this.props.dealStatus.id == status.id}
            selectedClass={status.selectedClass}
          />
        )}
      </div>
    );
  }
});

module.exports = DealStatusBox;



// WEBPACK FOOTER //
// ./app/shared/components/Hover/deal-status-box.jsx